import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./styles.css";

const SITUACAO_ATIVO = 1;

const Mapa = () => {
  const [dadosMotoristas, setdadosMotoristas] = useState([]);
  const [filtroMotorista, setFiltroMotorista] = useState(""); // Estado do filtro
  const [listaMotoristas, setListaMotoristas] = useState([]); // Lista para popular select
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaListaMotorista(filtroMotorista);
    carregaListaMotoristasParaFiltro();

    const intervalo = setInterval(() => {
      carregaListaMotorista(filtroMotorista);
    }, 60000);
    return () => clearInterval(intervalo);
  }, [filtroMotorista]); // Recarrega dados se o filtro mudar

  function filtrarMotoristasAtivos(lista = []) {
    return lista.filter((motorista) => Number(motorista.situacao) === SITUACAO_ATIVO);
  }

  async function carregaListaMotorista(busca) {
    let retorno = await buscaMotoristas(busca);
    if (retorno) {
      if (retorno.data) {
        setdadosMotoristas(filtrarMotoristasAtivos(retorno.data));
      } else {
        setdadosMotoristas([]);
      }
    }
  }

  async function carregaListaMotoristasParaFiltro() {
  try {
    const response = await api.get('/motoristas'); // SEM filtro aqui
    if (response.data) {
      setListaMotoristas(filtrarMotoristasAtivos(response.data));
    }
  } catch (error) {
    console.log(error);
    setListaMotoristas([]);
  }
}

  async function buscaMotoristas(busca) {
    try {
      // Se busca estiver vazia, busca todos
      const url = busca ? `/motoristas?filter=${busca}` : "/motoristas";
      const response = await api.get(url);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function classeMotorista(sit) {
    switch (sit) {
      case 0:
        return "icon-label MapaPreto";
      case 1:
        return "icon-label MapaAmarelo";
      case 2:
        return "icon-label MapaAzul";
      case 3:
        return "icon-label MapaVermelho";
      default:
        return "icon-label MapaPreto";
    }
  }

  const latitude = -15.2436862;
  const longitude = -53.6479108;

  return (
    <div>
      <div className="map-container">
        <MenuLateral />
        <div className="rowMapa">
          <h4>Monitoramento De Entregas</h4>

          {/* Filtro de Motorista */}
          <div style={{ paddingLeft: "5%", marginBottom: 10 }}>
            <label htmlFor="filtroMotorista">
              Filtrar Motorista:{" "}
              <select
                id="filtroMotorista"
                value={filtroMotorista}
                onChange={(e) => setFiltroMotorista(e.target.value)}
              >
                <option value="">Todos</option>
                {listaMotoristas.map((m) => (
                  <option key={m.IDusuario} value={m.IDusuario}>
                    { ('000000' + m.IDusuario).slice(-6)+' - ' + m.nome }
                  </option>
                ))}
              </select>
            </label>
          </div>

          <p style={{ paddingLeft: "5%", fontSize: "0.6em" }}>Legenda:</p>
          <div className="legendaMapa">
            <div className="corMapa MapaPreto"></div> <p><b>Sem internet</b></p>
            <div className="corMapa MapaAzul"></div> <p><b>Efetuando entrega</b></p>
            <div className="corMapa MapaAmarelo"></div> <p><b>Em trânsito</b></p>
            <div className="corMapa MapaVermelho"></div> <p><b>Parado</b></p>
          </div>
        </div>

        <MapContainer
          center={[latitude, longitude]}
          zoom={5}
          style={{ height: "100vh", width: "85%" }}
        >
          <TileLayer
            attribution="<p>GRUPO PALMARES</p>"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {dadosMotoristas.map((motorista) => {
            const divIcon = L.divIcon({
              className: classeMotorista(motorista.situacao_motorista),
              html: `<div class="${classeMotorista(
                motorista.situacao_motorista
              )}"><p>${motorista.placa}</p></div>`,
            });

            return (
              <Marker
                position={[motorista.latitude, motorista.longitude]}
                icon={divIcon}
                key={motorista.IDusuario}
              >
                <Popup>
                  {String(motorista.IDusuario).padStart(6, "0") +
                    "  -  " +
                    motorista.nome}{" "}
                  <br />
                  {motorista.modelo +
                    " - ANO: " +
                    motorista.ano_modelo +
                    " - PLACA: " +
                    motorista.placa}
                  <br />
                  <br />
                  <button
                    type="button"
                    className="btn btn-secondary btn-lg"
                    style={{
                      fontSize: "15px",
                      padding: "2px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      marginLeft: "43%",
                    }}
                    onClick={() => {
                      navigate(`/Motorista/${motorista.IDusuario}`);
                    }}
                  >
                    Ver
                  </button>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default Mapa;
